import React from 'react';
import { motion } from 'framer-motion';
import { SectionDivider } from './SectionDivider';
export function Problem() {
  return <section className="bg-brand-alt py-14" data-id="element-109">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-110">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-111">
          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-brand-text" data-id="element-112">
            EL PROBLEMA
          </h2>

          <div className="space-y-4 text-lg md:text-xl text-brand-subtext leading-relaxed" data-id="element-113">
            <p data-id="element-114">Querías emprender con velas.</p>
            <p data-id="element-115">
              Buscaste tutoriales en YouTube. Cada video decía algo diferente.
              Compraste materiales. Los resultados fueron inconsistentes.
              Gastaste más de lo que esperabas. Y ese proyecto quedó "en pausa".
            </p>
            <p className="text-2xl font-heading font-semibold text-brand-text mt-6 italic" data-id="element-116">
              El problema no eres tú. Es que nunca tuviste un método.
            </p>
          </div>
        </motion.div>
      </div>
      <SectionDivider data-id="element-117" />
    </section>;
}